export abstract class TableDialog<T> {
}
